export function PolishDeclination (_number: number, _declinations: Array<string>): string {
  if (_number === 1) {
    return _declinations[0] || '';
  }
  else if ((_number < 10 || _number > 20) && _number % 10 >= 2 && _number % 10 <= 4) {
    return _declinations[1] || '';
  }
  else {
    return _declinations[2] || '';
  }
}
